module.exports = __webpack_public_path__ + "media/turno_audio.b506a66a.mp3";